import React from "react";
import PluralityBallot from "./PluralityBallot";
import ApprovalBallot from "./ApprovalBallot";
import StarBallot from "./StarBallot";
import RcvBallot from "./RcvBallot";

export default function Ballot({
  method,
  race,
  candidates,
  onUpdate,
  defaultRankings,
  readonly
}) {
  const ballot = (function(method) {
    switch (method) {
      case "plurality":
        return PluralityBallot;
      case "approval":
        return ApprovalBallot;
      case "star":
        return StarBallot;
      case "rcv":
        return RcvBallot;
      default:
        return "";
    }
  })(method);
  return (
    <>
      {ballot
        ? ballot({ race, candidates, onUpdate, defaultRankings, readonly })
        : ""}
    </>
  );
}
